import { render, staticRenderFns } from "./dialogAccout.vue?vue&type=template&id=80520e94&scoped=true"
import script from "./dialogAccout.vue?vue&type=script&lang=js"
export * from "./dialogAccout.vue?vue&type=script&lang=js"
import style0 from "./dialogAccout.vue?vue&type=style&index=0&id=80520e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80520e94",
  null
  
)

export default component.exports